import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  title: { id: 'blob_eos_daily_goal_reached_title', defaultMessage: 'You smashed today’s goal!' },
  body: {
    id: 'blob_eos_daily_goal_reached_body',
    defaultMessage: 'Come back tomorrow, or keep going to get ahead.',
  },
});

export const DailyGoalBanner: FC = () => {
  const intl = useIntl();

  return (
    <S.Banner role="status" data-testid="blob-eos-daily-goal-banner">
      <S.Check>
        <Icon name="check" />
      </S.Check>
      <S.Text>
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title> {intl.formatMessage(msgs.body)}
      </S.Text>
    </S.Banner>
  );
};
